/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Request to create a virtual device. You can either specify a `deviceProfileId` or `deviceProfile` definition that will be automatically provisioned. */
export type VirtualDeviceCreateRequest = {
  owner: DeviceOwner;
  /** Device profile identifier for a virtual device. Required unless the `deviceProfile` field is populated. */
  deviceProfileId?: DeviceProfileId;
  deviceProfile?: DeviceProfile;
  /** The name of the device. */
  name: Name;
  /**
   * ID of the room to install the device into. Only applicable for `LOCATION` owned devices.
   * @format uuid
   */
  roomId?: string;
  commandMappings?: CommandMappings;
  /** The environmental context in which this device executes. */
  executionTarget?: ExecutionTarget;
  /** Identifier for the hub associated with a virtual device (only applicable for locally executing devices). */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** the ID of the Edge channel containing the driver ID. */
  channelId?: ChannelId;
};

/** Request to create a virtual device from a prototype. */
export type VirtualDeviceFromPrototypeRequest = {
  /** The name of the device. */
  name: Name;
  /**
   * The prototype type, or template, that will determine the kind of device created.
   * @example "VIRTUAL_SWITCH"
   */
  prototype:
    | 'VIRTUAL_BUTTON'
    | 'VIRTUAL_CAMERA'
    | 'VIRTUAL_COLOR_BULB'
    | 'VIRTUAL_CONTACT_SENSOR'
    | 'VIRTUAL_DIMMER'
    | 'VIRTUAL_DIMMER_SWITCH'
    | 'VIRTUAL_GARAGE_DOOR_OPENER'
    | 'VIRTUAL_HUMIDITY_SENSOR'
    | 'VIRTUAL_LOCK'
    | 'VIRTUAL_METERED_SWITCH'
    | 'VIRTUAL_MOTION_SENSOR'
    | 'VIRTUAL_MULTI_SENSOR'
    | 'VIRTUAL_PRESENCE_SENSOR'
    | 'VIRTUAL_REFRIGERATOR'
    | 'VIRTUAL_REMOTE'
    | 'VIRTUAL_RGBW_BULB'
    | 'VIRTUAL_SIREN'
    | 'VIRTUAL_SMOKE_DETECTOR'
    | 'VIRTUAL_SWITCH'
    | 'VIRTUAL_TEMPERATURE_SENSOR'
    | 'VIRTUAL_THERMOSTAT'
    | 'VIRTUAL_WATER_SENSOR'
    | 'VIRTUAL_WATER_VALVE'
    | 'VIRTUAL_WHITE_BULB'
    | 'VIRTUAL_WINDOW_TREATMENT';
  owner: DeviceOwner;
  /**
   * ID of the room to install the device into. Only applicable for `LOCATION` owned devices.
   * @format uuid
   */
  roomId?: string;
  /** The environmental context in which this device executes. */
  executionTarget?: ExecutionTarget;
  /** Identifier for the hub associated with a virtual device (only applicable for locally executing devices). */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** the ID of the Edge channel containing the driver ID. */
  channelId?: ChannelId;
};

export type MigrateVirtualDeviceRequest = MigratedDeviceBase &
  MigratedDeviceBaseManufacturerInfo & {
    /**
     * The prototype type, or template, that will determine the kind of device created.
     * @example "VIRTUAL_SWITCH"
     */
    prototype?:
      | 'VIRTUAL_BUTTON'
      | 'VIRTUAL_CAMERA'
      | 'VIRTUAL_COLOR_BULB'
      | 'VIRTUAL_CONTACT_SENSOR'
      | 'VIRTUAL_DIMMER'
      | 'VIRTUAL_DIMMER_SWITCH'
      | 'VIRTUAL_GARAGE_DOOR_OPENER'
      | 'VIRTUAL_HUMIDITY_SENSOR'
      | 'VIRTUAL_LOCK'
      | 'VIRTUAL_METERED_SWITCH'
      | 'VIRTUAL_MOTION_SENSOR'
      | 'VIRTUAL_MULTI_SENSOR'
      | 'VIRTUAL_PRESENCE_SENSOR'
      | 'VIRTUAL_REFRIGERATOR'
      | 'VIRTUAL_REMOTE'
      | 'VIRTUAL_RGBW_BULB'
      | 'VIRTUAL_SIREN'
      | 'VIRTUAL_SMOKE_DETECTOR'
      | 'VIRTUAL_SWITCH'
      | 'VIRTUAL_TEMPERATURE_SENSOR'
      | 'VIRTUAL_THERMOSTAT'
      | 'VIRTUAL_WATER_SENSOR'
      | 'VIRTUAL_WATER_VALVE'
      | 'VIRTUAL_WHITE_BULB'
      | 'VIRTUAL_WINDOW_TREATMENT';
  };

export type MigrateVirtualDeviceResponse = DeviceResponse & MigratedDeviceBaseManufacturerInfo;

export interface MigratedDeviceBaseManufacturerInfo {
  /** Reported manufacturer of the device */
  manufacturer?: DeviceManufacturer;
  /** Reported model of the device */
  model?: DeviceModel;
  /** Name for device provided by Vender. Required since LAN devices could be accessible in other applications and have differing names */
  vendorProvidedLabel?: VendorProvidedLabel;
}

/**
 * Reported manufacturer of the device
 * @example "SmartThings"
 */
export type DeviceManufacturer = string;

/**
 * Reported model of the device
 * @example "motionv4"
 */
export type DeviceModel = string;

/**
 * Name for device provided by Vender. Required since LAN devices could be accessible in other applications and have differing names
 * @example "Living Room Light"
 */
export type VendorProvidedLabel = string;

/** Replicator device details. */
export interface ReplicatorDevice {
  /** Identifier for a virtual device. */
  deviceId?: DeviceId;
  /** The name of the device. */
  name?: Name;
  /** The last time the device was written. This is in java Instant format. */
  updatedDate?: UpdatedDate;
  commandMappings?: CommandMappings;
  /** The environmental context in which this device executes. */
  executionTarget?: ExecutionTarget;
  /** Identifier for the hub associated with a virtual device (only applicable for locally executing devices). */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
}

export interface CommandMappings {
  commands?: CommandMapping[];
}

/**
 * A mapping of `commandName` to `attribute.value` that will allow users to support complex commands that would otherwise
 * not be determinable simply by the capabililty contract.
 */
export interface CommandMapping {
  /** The Capability ID. */
  capabilityId: string;
  /** The Capability version number. */
  version: number;
  /** The command name to apply the mapping to on the device */
  command: string;
  /** A collection of attribute values, replicator will use these to create device events in serial for the specified command. */
  eventValues: AttributeValue[];
}

/** The description of an attribute value that will be used to populate an event. */
export interface AttributeValue {
  /** The attribute that this command will correspond to */
  attribute?: string;
  /** How will the attribute be provided? Choose either to provide it with a command at runtime or to provide a set value here. */
  inputType?: 'STATIC' | 'ARGUMENT';
  /** The argument to be used automatically for this command mapping. Any simple type is accepted. */
  staticValue?: object;
}

export interface MigratedDeviceBase {
  /** Collection of information records to associate with Device. */
  deviceData?: DeviceData;
  /** The network-specific identifier of the device on the network */
  deviceNetworkId: DeviceNetworkId;
  /** The hub that the device is connected to. */
  hubId: HubId;
  /** The identifier for the Device instance. */
  id: DeviceId;
  /** The label for the Device. */
  label: DeviceLabel;
  legacyProperties: LegacyProperties;
  /** Provisioning type for a widget device */
  provisioningState: ProvisioningState;
}

export interface DeviceProfile {
  /**
   * A name for the implicit profile. Names have no uniqueness or null constraints.
   * @format ^(?!\s)[-_!.~'() *0-9a-zA-Z\p{L}]{1,100}(?<!\s)$
   * @minLength 1
   * @maxLength 100
   * @example "thermostat1.model1"
   */
  name?: string;
  /**
   * A list of components for this profile. Exactly 1 component ID must be `main`.
   * @maxItems 20
   * @minItems 1
   */
  components: DeviceComponentRequest[];
  /** Additional information about the device profile, limited to 10 entries. */
  metadata?: DeviceProfileMetadata;
  /** The restriction to limit actions a device can take. */
  restrictions?: DeviceRestriction;
  /** A list of preferences for this profile, whether implicit or explicit. */
  preferences?: PreferenceRequest[];
  config?: DeviceProfileConfig;
}

export type DeviceOwner = {
  /** The type of owner the device will be installed with. Currently only `LOCATION` is available, but with the intention of supporting `USER` later on. */
  ownerType?: DeviceOwnerType;
  /** The owner ID for the device. */
  ownerId?: OwnerId;
};

/**
 * A request to create a replicator device, or migrate an existing device into a replicator device.
 * Note: An `Override Owner` can only be specified for a `clone` operation.
 */
export type ReplicateRequest = {
  /** Identifier for a virtual device. */
  deviceId: DeviceId;
  /**
   * The replication operation we want to perform.
   * `CLONE` - Will create a new device copied from the specified device. Perfect for testing what an existing device would look/act like as a replicator device.
   */
  replicateOperation: ReplicateOperation;
  overrideOwner?: DeviceOwner;
};

/**
 * Identifier for a virtual device.
 * @format uuid
 */
export type DeviceId = string;

/**
 * Device profile identifier for a virtual device. Required unless the `deviceProfile` field is populated.
 * @format uuid
 */
export type DeviceProfileId = string;

/**
 * The location ID the device is installed into. May be blank for a "user level" virtual device.
 * @format uuid
 */
export type LocationId = string;

/** The owner ID for the device. */
export type OwnerId = string;

/**
 * The type of owner the device will be installed with. Currently only `LOCATION` is available, but with the intention of supporting `USER` later on.
 * @example "LOCATION"
 */
export enum DeviceOwnerType {
  LOCATION = 'LOCATION',
}

/**
 * Identifier for the hub associated with a virtual device (only applicable for locally executing devices).
 * @format uuid
 */
export type HubId = string;

/**
 * the ID of the Edge channel containing the driver ID.
 * @format uuid
 */
export type ChannelId = string;

/**
 * The environmental context in which this device executes.
 * @default "CLOUD"
 * @example "CLOUD"
 */
export enum ExecutionTarget {
  CLOUD = 'CLOUD',
  LOCAL = 'LOCAL',
}

/**
 * The name of the device.
 * @example "Virtual Switch"
 */
export type Name = string;

/**
 * The replication operation we want to perform.
 * `CLONE` - Will create a new device copied from the specified device. Perfect for testing what an existing device would look/act like as a replicator device.
 * @example "CLONE"
 */
export enum ReplicateOperation {
  CLONE = 'CLONE',
}

/**
 * The last time the device was written. This is in java Instant format.
 * @example "2015-06-02T21:34:33.616Z"
 */
export type UpdatedDate = string;

export interface Device {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The identifier for the owner of the device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "color.light.100x"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device manufacturer name.
   * @example "SmartThings"
   */
  manufacturerName: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * An non-unique id that is used to help drive UI information.
   * @example "VD-STV_2018_K"
   */
  presentationId: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /** The IDs of all locations this device is shared with. */
  sharedLocations?: SharedLocation[];
  /** The IDs of all compenents on the device. */
  components?: DeviceComponent[];
  /** The time when the device was created at. */
  createTime?: string;
  healthState?: IdLessHealthState;
  /** The id of the Parent device. */
  parentDeviceId?: string;
  /** Device details for all child devices of the device. */
  childDevices?: ChildDeviceRef[];
  profile?: DeviceProfileReference;
  /** Device Profile information for a SmartApp. This field will be empty if device type is not ENDPOINT_APP. */
  app?: AppDeviceDetails;
  /** Bluetooth device information. This field will be empty if device type is not BLE. */
  ble?: BleDeviceDetails;
  /** Bluetooth device to device information. This field will be empty if device type is not BLE_D2D. */
  bleD2D?: BleD2DDeviceDetails;
  /** Device Profile information for DTH. This field will be empty if device type is not DTH. */
  dth?: DthDeviceDetails;
  /** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
  lan?: LanDeviceDetails;
  /** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
  zigbee?: ZigbeeDeviceDetails;
  /** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
  zwave?: ZwaveDeviceDetails;
  /** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
  matter?: MatterDeviceDetails;
  /** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
  edgeChild?: EdgeChildDeviceDetails;
  /** HUB device information. This field will be empty if the device type is not HUB. */
  hub?: HubDeviceDetails;
  /** MOBILE device information. This field will be empty if the device type is not MOBILE. */
  mobile?: MobileDeviceDetails;
  /** IR device information. This field will be empty if device type is not IR. */
  ir?: IrDeviceDetails;
  /** IR_OCF device information. This field will be empty if device type is not IR_OCF. */
  irOcf?: IrDeviceDetails;
  /** OCF device information. This field will be empty if device type is not OCF. */
  ocf?: OcfDeviceDetails;
  /** Viper device information. This field will be empty if device type is not VIPER. */
  viper?: ViperDeviceDetails;
  /** Group device information. This field will be empty if device type is not GROUP. */
  group?: GroupDeviceDetails;
  /** Virtual device information. This field will be empty if device type is not VIRTUAL. */
  virtual?: VirtualDeviceDetails;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * *DEPRECATED* please use `presentationId`
   * Vendor id of the device, used for UI.
   */
  vid?: string;
  /**
   * *DEPRECATED* please use `manufacturerName`
   * Manufacturer model number, used for UI.
   */
  mnmn?: string;
  /** The OCF device type (resource), used for UI. */
  ocfDeviceType?: string;
  /** Restriction tier of the device, if any. */
  restrictionTier: number;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:devices - the user can change device details
   *   <li> w:devices:locationId - the user can move the device from a location
   *   <li> w:devices:roomId - the user can move or remove the device from a room
   *   <li> x:devices - the user can execute commands on the device
   *   <li> d:devices - the user can uninstall the device
   *   </ul>
   * @uniqueItems true
   */
  allowed?: 'w:devices' | 'w:devices:locationId' | 'w:devices:roomId' | 'x:devices' | 'd:devices';
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

/** A paginated array of Devices. */
export interface PagedDevices {
  items?: Device[];
  _links?: Links;
}

export interface AppDeviceDetails {
  /**
   * The ID of the installed app that integrates this device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  installedAppId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  profile?: DeviceProfileReference;
}

export type BleDeviceDetails = object;

export interface BleD2DDeviceDetails {
  /**
   * Security encryption key.
   * @example "96012869B606355A1F843B1E19DC31B1"
   */
  encryptionKey?: string;
  /**
   * Key for the decrypt.
   * @example "BMO_256-CBS-PKMS1Padding"
   */
  cipher?: string;
  /**
   * BLE Advertising Id.
   * @example "9C0D4219"
   */
  advertisingId?: string;
  /**
   * Unique device identifier.
   * @example "88-57-1d-0e-53-ab"
   */
  identifier?: string;
  configurationVersion?: string;
  /** @example "https://apisa.samsungiots.com/v1/miniature/profile/e524ceba-93b9-499d-a90a-24214f7f01cb" */
  configurationUrl?: string;
  metadata?: object;
}

export interface DeviceProfileReference {
  /**
   * The device profile Id
   * @example "a7b3c264-2d22-416e-bca1-ca4b59a60aee"
   */
  id?: string;
}

export interface DeviceIntegrationProfileKey {
  /**
   * Unique identifier for integration profile.
   * @format uuid
   */
  id: string;
  /**
   * Major Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  majorVersion: number;
  /**
   * Minor Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  minorVersion?: number;
  /**
   * @format uuid
   * @example "a362ddb6-349b-4650-9911-681b51069a57"
   */
  overrideProfileId?: string;
}

export interface DthDeviceDetails {
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup: boolean;
  /** The device network type. */
  deviceNetworkType?: DeviceNetworkType;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  deviceTypeId: string;
  /**
   * The name for the device's DeviceType.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * The ID of the installed groovy application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8f5ra619-4c05-4a90-a245-cc129b0a8098"
   */
  installedGroovyAppId?: string;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
}

export type DeviceCapabilityReference = CapabilityReference & {
  /** A map of Attribute name to Attribute state. */
  status?: CapabilityStatus;
};

/**
 * A map of Attribute name to Attribute state.
 * @example {"switch":{"value":"on"}}
 */
export type CapabilityStatus = Record<string, AttributeState>;

export interface AttributeState {
  /** @example 0 */
  value?: object;
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

/**
 * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
 * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
 * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
 * @default "UNKNOWN"
 */
export enum DeviceNetworkSecurityLevel {
  UNKNOWN = 'UNKNOWN',
  ZWAVE_LEGACY_NON_SECURE = 'ZWAVE_LEGACY_NON_SECURE',
  ZWAVES0LEGACY = 'ZWAVE_S0_LEGACY',
  ZWAVES0FALLBACK = 'ZWAVE_S0_FALLBACK',
  ZWAVES2UNAUTHENTICATED = 'ZWAVE_S2_UNAUTHENTICATED',
  ZWAVES2AUTHENTICATED = 'ZWAVE_S2_AUTHENTICATED',
  ZWAVES2ACCESSCONTROL = 'ZWAVE_S2_ACCESS_CONTROL',
  ZWAVES2FAILED = 'ZWAVE_S2_FAILED',
  ZWAVES0FAILED = 'ZWAVE_S0_FAILED',
  ZWAVES2DOWNGRADE = 'ZWAVE_S2_DOWNGRADE',
  ZWAVES0DOWNGRADE = 'ZWAVE_S0_DOWNGRADE',
}

/** HUB device information. This field will be empty if the device type is not HUB. */
export interface HubDeviceDetails {
  /**
   * The unique identifier for this manufactured hub.
   * @format ^[0-9A-F]{16}$
   * @example "D053A8B4F6D80001"
   */
  hubEui: string;
  /**
   * The hub's firmware version
   * @format ^[0-9]\.[0-9]\.[0-9]{3}$
   * @example ""
   */
  firmwareVersion: string;
  /** A list of drivers installed on the hub */
  hubDrivers: HubDriver[];
  hubData: {
    /**
     * Zwave static DSK for the hub.
     * @example "21720-31296-41384-03009-58023-25366-38831-43982"
     */
    zwaveStaticDsk?: string;
    /** Whether zwaveS2 is enabled for this hub. */
    zwaveS2: boolean;
    /**
     * The hardwareType for this hub
     * @example "V3_HUB"
     */
    hardwareType: string;
    /**
     * The hub's hardware ID
     * @example "00A2"
     */
    hardwareId?: string;
    /**
     * The Zigbee firmware version for this hub
     * @example "5.4.0"
     */
    zigbeeFirmware?: string;
    /** Whether the hub supports zigbee3 */
    zigbee3: boolean;
    /** Describes state of Zigbee OTA. */
    zigbeeOta?: ZigbeeOta;
    /** Indicates if Zigbee OTA is enabled. */
    otaEnable?: string;
    /** Whether the hub allows zigbee unsecure rejoin */
    zigbeeUnsecureRejoin: boolean;
    /** Possible Values for Hub Characteristic "Availability" flags */
    primarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    secondarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zigbeeAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zwaveAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    threadAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    lanAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    matterAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    localVirtualDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    childDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    edgeDriversAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    hubReplaceAvailability?: AvailabilityCharacteristic;
    /** The primary hub device id for this hub. Null/Empty if hub is not a repeater. */
    primaryHubDeviceId?: string;
    /** The Zigbee Channel of the Hub. */
    zigbeeChannel?: string;
    /** The Personal Area Network (PAN) id of the zigbee network the hub is on. */
    zigbeePanId?: string;
    /** The unique identifier for this manufactured hub. */
    zigbeeEui?: string;
    /** The short address of a node in Zigbee network. */
    zigbeeNodeID?: string;
    /** The address of a single node in the network */
    zwaveNodeID?: string;
    /** The common identification of all nodes belonging to one logical Z-Wave network */
    zwaveHomeID?: string;
    zwaveSucID?: string;
    zwaveVersion?: string;
    /** The global region this zwave radio is operating in. */
    zwaveRegion?: string;
    /** MAC address of the hubs network interface. */
    macAddress?: string;
    /** IP address of the hub. */
    localIP?: string;
    /** Whether the hub is zigbee radio functional. */
    zigbeeRadioFunctional?: boolean;
    /** Whether the hub is zwave radio functional. */
    zwaveRadioFunctional?: boolean;
  };
}

/** MOBILE device information. This field will be empty if the device type is not MOBILE. */
export type MobileDeviceDetails = object;

export interface IrDeviceDetails {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCode?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDeviceDetails[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

export interface OcfDeviceDetails {
  /** OCF device type */
  ocfDeviceType?: string;
  /** Name of the device */
  name?: string;
  /** OCF spec version */
  specVersion?: string;
  /** OCF vertical domain spec version */
  verticalDomainSpecVersion?: string;
  /** OCF manufacturer name */
  manufacturerName?: string;
  /** OCF model number */
  modelNumber?: string;
  /** OCF platform version */
  platformVersion?: string;
  /** OCF platform OS */
  platformOS?: string;
  /** OCF platform H/W version */
  hwVersion?: string;
  /** OCF firmware version */
  firmwareVersion?: string;
  /** OCF vendor ID */
  vendorId?: string;
  /** OCF vendor resource client/server version */
  vendorResourceClientServerVersion?: string;
  /** Language code */
  locale?: string;
  /** The time when the device is signed up lastly */
  lastSignupTime?: string;
}

/** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
export interface LanDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
export interface ZigbeeDeviceDetails {
  /** The EUID of the Zigbee device */
  eui?: DeviceEui;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/**
 * Describes state of Zigbee OTA.
 * @default "DISABLED"
 */
export enum ZigbeeOta {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  ENABLED_WITH_LIGHTS = 'ENABLED_WITH_LIGHTS',
}

/**
 * 16-bit manufacturer identifier assigned by the Z-Wave Specification
 * @min 0
 * @max 65535
 * @example 134
 */
export type ZWaveManufacturerId = number;

/**
 * 16-bit manufacturer defined product type
 * @min 0
 * @max 65535
 * @example 17488
 */
export type ZWaveProductType = number;

/**
 * 16-bit manufacturer defined product identifier
 * @min 0
 * @max 65535
 * @example 12336
 */
export type ZWaveProductId = number;

/** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
export interface ZwaveDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product type */
  productType?: ZWaveProductType;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
}

/** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
export interface MatterDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** Vendor-supplied unique identifier. Optional. */
  uniqueId?: string;
  /** 16-bit vendor id. Optional. */
  vendorId?: number;
  /** 16-bit product id. Optional. */
  productId?: number;
  /** Listening type for the device. Optional. */
  listeningType?: MatterListeningType;
  /** List of network interfaces. Optional. */
  supportedNetworkInterfaces?: MatterNetworkInterfaces;
  /** Hardware and Software version info for matter devices. Optional. */
  version?: MatterVersion;
  /** Available Matter endpoints */
  endpoints?: MatterEndpoints;
  /** Determines whether or not to sync the child device's driver from its parent. Default is true. */
  syncDrivers?: SyncDrivers;
}

/** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
export interface EdgeChildDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The identifier assigned to this edge child device by its parent */
  parentAssignedChildKey?: ParentAssignedChildKey;
}

export interface HubDriver {
  /** The version of the driver revision being returned */
  driverVersion?: string;
  /**
   * The identifier of the Sprocket driver
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  driverId: string;
  /**
   * The identifier of the Sprocket channel
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  channelId?: string;
}

/** The identifier assigned to this edge child device by its parent */
export type ParentAssignedChildKey = string;

/**
 * Possible Values for Hub Characteristic "Availability" flags
 * @example "Available"
 */
export enum AvailabilityCharacteristic {
  Available = 'Available',
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

/** The network-specific identifier of the device on the network */
export type DeviceNetworkId = string;

/**
 * The identifier for the Device instance.
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */

// removed this line because it is a duplicate definition
// export type DeviceId = string;

export interface DeviceEventsRequest {
  /**
   * An array of attribute state updates.
   * @maxItems 8
   * @minItems 1
   */
  deviceEvents?: DeviceStateEvent[];
}

/** @example {"component":"main","capability":"switchLevel","attribute":"level","value":0,"unit":null,"data":null} */
export interface DeviceStateEvent {
  /** The name of the component on this device, default is 'main'. */
  component?: string;
  /** Capability that this event relates to. */
  capability?: string;
  /** Name of the capability attribute that this event relates to. */
  attribute?: string;
  /** Value associated with the event. The valid value depends on the capability. */
  value: object;
  /** Unit of the value field. */
  unit?: string;
  /** Key value pairs about the state of the device. Valid values depend on the capability. */
  data?: Record<string, object>;
  /** The id on the command that triggered this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

/**
 * The EUID of the Zigbee device
 * @example "24FD5B000105DB96"
 */
export type DeviceEui = string;

/**
 * The device network type.
 * @example "ZIGBEE"
 */
export type DeviceNetworkType = string;

/**
 * The ID of the Sprocket driver
 * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
 * @example "9314a926-528c-403f-ae56-4b0d059381dd"
 */
export type DriverId = string;

/** Listening type for the device. Optional. */
export enum MatterListeningType {
  ALWAYS = 'ALWAYS',
  SLEEPY = 'SLEEPY',
}

/** Hardware and Software version info for matter devices. Optional. */
export interface MatterVersion {
  /**
   * 16-bit hardware version. Optional.
   * @min 0
   * @max 65535
   * @example 771
   */
  hardware?: number;
  /** Label for the hardware version. Optional. */
  hardwareLabel?: string;
  /**
   * 32-bit software version. Optional.
   * @min 0
   * @max 4294967295
   * @example 50529027
   */
  software?: number;
  /** Label for the hardware version. Optional. */
  softwareLabel?: string;
}

/** List of network interfaces. Optional. */
export type MatterNetworkInterfaces = MatterNetworkInterface[];

/** Supported Network Interfaces of the Device */
export enum MatterNetworkInterface {
  THREAD = 'THREAD',
  WIFI = 'WIFI',
  ETHERNET = 'ETHERNET',
}

/** Available Matter endpoints */
export type MatterEndpoints = MatterEndpoint[];

/** Matter device endpoint */
export interface MatterEndpoint {
  /**
   * 16-bit identifier for the endpoint
   * @min 0
   * @max 65535
   * @example 771
   */
  endpointId?: number;
  /** List of device types for the endpoint */
  deviceTypes?: MatterEndpointDeviceType[];
}

/** Device type for a matter endpoint */
export interface MatterEndpointDeviceType {
  /**
   * 32-bit identifier for the device type
   * @min 0
   * @max 4294967295
   * @example 197379
   */
  deviceTypeId?: number;
}

/**
 * Determines whether or not to sync the child device's driver from its parent. Default is true.
 * @example true
 */
export type SyncDrivers = boolean;

/** True if the device is executing locally on the hub */
export type ExecutingLocally = boolean;

/**
 * The hub that the device is connected to.
 * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
 */

// removed this line because it is a duplicate definition
// export type HubId = string;

/** Provisioning type for a widget device */
export enum ProvisioningState {
  PROVISIONED = 'PROVISIONED',
  TYPED = 'TYPED',
  DRIVER_SWITCH = 'DRIVER_SWITCH',
  NONFUNCTIONAL = 'NONFUNCTIONAL',
}

export interface ViperDeviceDetails {
  /** @example "1a-74" */
  uniqueIdentifier?: string;
  /** @example "TP-Link" */
  manufacturerName?: string;
  /** @example "HS101" */
  modelName?: string;
  /** @example "23.123.231" */
  swVersion?: string;
  /** @example "v1 US bulb" */
  hwVersion?: string;
  /** @example "viper_bb238c20-675a-11ed-970f-571777eb58c5" */
  endpointAppId?: string;
}

export interface GroupDeviceDetails {
  /** @example "My Group" */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  devices?: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
     */
    deviceId: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
}

/**
 * The type of the group in question
 *
 * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
 */
export enum DeviceGroupType {
  UNDETERMINED = 'UNDETERMINED',
  GENERIC = 'GENERIC',
  VIDEO_CAMERA = 'VIDEO_CAMERA',
  LIGHTING = 'LIGHTING',
}

/** An array of devices in the group */
export interface DeviceGroupDevice {
  /**
   * GUID representing the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
   */
  deviceId: string;
  /** Components to add to the group */
  components?: {
    /** @example "main" */
    id?: string;
    [key: string]: any;
  }[];
}

export interface VirtualDeviceDetails {
  /** Name of the device */
  name?: string;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  commandMappings?: CommandMappings;
}

/**
 * The type of device integration.
 * All types besides ENDPOINT_APP will have profile populated.
 * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
 * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
 * If the type is IR, the details are in the "ir" field.
 * If the type is IR_OCF, the details are in the "irOcf" field.
 * If the type is VIPER, the details are in the "viper" field.
 */
export enum DeviceIntegrationType {
  APP = 'APP',
  BLE = 'BLE',
  BLED2D = 'BLE_D2D',
  DTH = 'DTH',
  ENDPOINT_APP = 'ENDPOINT_APP',
  GROUP = 'GROUP',
  HUB = 'HUB',
  IR = 'IR',
  IR_OCF = 'IR_OCF',
  LAN = 'LAN',
  MATTER = 'MATTER',
  MOBILE = 'MOBILE',
  MQTT = 'MQTT',
  OCF = 'OCF',
  PENGYOU = 'PENGYOU',
  SHP = 'SHP',
  VIDEO = 'VIDEO',
  VIPER = 'VIPER',
  VIRTUAL = 'VIRTUAL',
  WATCH = 'WATCH',
  ZIGBEE = 'ZIGBEE',
  ZWAVE = 'ZWAVE',
  EDGE_CHILD = 'EDGE_CHILD',
}

export interface ChildDeviceRef {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  id?: string;
}

export interface PagedDeviceComponents {
  items?: DeviceComponent[];
  _links?: Links;
}

/**
 * The location of a device on a floorplan map, if any.
 * @example {"coordinates":["1.0","2.0","3.0"],"rotation":["0","0","0"],"visible":true,"data":[{"extraData1":"some data"}]}
 */
export interface IndoorMap {
  /**
   * The coordinates to be used to map the device.
   * @maxItems 3
   * @minItems 3
   */
  coordinates?: number[];
  /**
   * The rotational data for the device.
   * @maxItems 3
   * @minItems 3
   */
  rotation?: number[];
  /** Whether or not the device is visible on the map. */
  visible?: boolean;
  /** Key value pairs to place additional information. */
  data?: Record<string, any>;
}

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface SharedLocation {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  locationId?: string;
}

/**
 * A typed model which provides information around ownership of a specific domain.
 * @example {"ownerType":"USER","ownerId":"72fd3b54-d243-4bf7-a845-92eb7956b982"}
 */
export interface Owner {
  /**
   * The type of owner that owns this entity. "Account" refers specifically to a coterie account ID.
   * @default "USER"
   */
  ownerType: 'USER' | 'SYSTEM' | 'IMPLICIT' | 'ACCOUNT';
  /** A global identifier for owner. */
  ownerId: string;
}

/** @example {"title":"Temperature Offset","description":"The offset for a particular temperature setting","required":false,"preferenceType":"number","definition":{"minimum":-10,"maximum":10,"default":0}} */
export interface PreferenceRequest {
  /** The ID of the preference */
  preferenceId?: string;
  /**
   * An alphanumeric English language name for this preference. Will be appended to a namespace to generate the full preference id.
   * @pattern ^[a-zA-Z0-9][a-zA-Z0-9 ]{1,35}$
   * @example "tempOffset"
   */
  name: string;
  /**
   * A short description for this preference.
   * @example "Temperature Offset"
   */
  title: string;
  /**
   * A long description for this preference.
   * @example "The offset for a particular temperature setting"
   */
  description?: string;
  /**
   * A flag describing whether this preference is explicit, or inline.
   * @default false
   */
  explicit?: boolean;
  /**
   * A flag describing whether this property is required or not.
   * @default false
   */
  required?: boolean;
  /** The type of preference this is. */
  preferenceType: PreferenceType;
  /** The definition of this preference. */
  definition: {
    /**
     * Minimum value a preference may be set to. Only valid for `integer` and `number` preference types.
     * @format double
     */
    minimum?: number;
    /**
     * Maximum value a preference may be set to. Only valid for `integer` and `number` preference types.
     * @format double
     */
    maximum?: number;
    /** Minimum length a string may be set to. Only valid for `string` preference type. */
    minLength?: number;
    /** Maximum length a string may be set to. Only valid for `string` preference type. */
    maxLength?: number;
    /** Default value for a preference. */
    default?: any;
    /** The type of a string preference. `text` is a normal preference, `password` encrypts the values, and `paragraph` is for documentation purposes. */
    stringType?: 'text' | 'password' | 'paragraph';
    /** The available selections for an `enumeration` preference. */
    options?: Record<string, string>;
  };
}

export interface PreferenceResponse {
  /** The ID of the preference */
  preferenceId?: string;
  /** An alphanumeric English language name for this preference. */
  name?: string;
  /**
   * A short description for this preference.
   * @example "Temperature Offset"
   */
  title: string;
  /**
   * A long description for this preference.
   * @example "The offset for a particular temperature setting"
   */
  description?: string;
  /**
   * A flag describing whether this property is required or not.
   * @default false
   */
  required?: boolean;
  /**
   * A flag describing whether this preference is explicit, or inline.
   * @default false
   */
  explicit?: boolean;
  /** The type of preference this is. */
  preferenceType: PreferenceType;
}

/** The type of preference this is. */
export enum PreferenceType {
  Integer = 'integer',
  Number = 'number',
  Boolean = 'boolean',
  String = 'string',
  Enumeration = 'enumeration',
}

/**
 * The definition of this preference.
 * @example {"id":"example.colorSelect","name":"colorSelect","title":"Color Select","description":"Select a preset color","required":false,"preferenceType":"enumeration","definition":{"options":{"red":"Red","yellow":"Yellow","lightBlue":"Light Blue"},"default":"red"}}
 */
export type EnumerationPreference = PreferenceResponse & {
  definition: {
    /** The available selections for an `enumeration` preference. */
    options: Record<string, string>;
    /** Default value for a preference. */
    default?: any;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.notificationMessage","name":"notificationMessage","title":"Notification Message","description":"Set the text of the notification message","preferenceType":"string","definition":{"stringType":"text","minLength":1,"maxLength":10}}
 */
export type StringPreference = PreferenceResponse & {
  definition?: {
    /** Minimum length a string may be set to. */
    minLength?: number;
    /** Maximum length a string may be set to. */
    maxLength?: number;
    /**
     * The type of a string preference.
     * `text` is a normal preference, `password` encrypts the values, and `paragraph` is for documentation purposes.
     * @default "text"
     */
    stringType?: 'text' | 'password' | 'paragraph';
    /** Default value for a preference. */
    default?: string;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.tempOffset","name":"tempOffset","title":"Temperature Offset","description":"Set the default temperature offset of this device","required":false,"preferenceType":"integer","definition":{"minimum":-10,"maximum":10,"default":0}}
 */
export type IntegerPreference = PreferenceResponse & {
  definition?: {
    /** Minimum value a preference may be set to. */
    minimum?: number;
    /** Maximum value a preference may be set to. */
    maximum?: number;
    /** Default value for a preference. */
    default?: number;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.lightToggleDelay","name":"lightToggleDelay","title":"Light Toggle Delay","description":"The delay time to toggle a light to turn on or off","required":false,"preferenceType":"number","definition":{"minimum":0,"maximum":1,"default":0.5}}
 */
export type NumberPreference = PreferenceResponse & {
  definition?: {
    /**
     * Minimum value a preference may be set to.
     * @format double
     */
    minimum?: number;
    /**
     * Maximum value a preference may be set to.
     * @format double
     */
    maximum?: number;
    /**
     * Default value for a preference.
     * @format double
     */
    default?: number;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.featureEnabled","name":"featureEnabled","title":"Feature Enabled","description":"Set the feature to enabled for this device","required":false,"preferenceType":"boolean","definition":{"default":true}}
 */
export type BooleanPreference = PreferenceResponse & {
  definition?: {
    /** Default value for a preference. */
    default?: boolean;
  };
};

/** The restriction to limit actions a device can take. */
export type DeviceRestriction = Restriction;

/** A typed model which describes a restriction pertaining to a platform entity. */
export interface Restriction {
  /** The restriction level of an entity to limit actions it can take. */
  tier: number;
  /** The number of days to retain the state before deletion. */
  historyRetentionTTLDays?: number;
  /**
   * Indicate whether or not the entity is visible when restricted.
   * @default false
   */
  visibleWhenRestricted?: boolean;
}

export interface IdLessHealthState {
  /** Current state of the device */
  state?: 'ONLINE' | 'OFFLINE';
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
}

export interface DeviceComponentRequest {
  /** UTF-8 label for the component. */
  label?: string;
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /**
   * A list of `[ 1..20 ]` capabilities for this component.
   * @maxItems 20
   * @minItems 1
   */
  capabilities: CapabilityReferenceRequest[];
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
}

export interface DeviceComponent {
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /** UTF-8 label for the component. */
  label?: string;
  capabilities: DeviceCapabilityReference[];
  /** Defines the categories for the device. There can be up to 2, one defined by the manufacturer the other is a user selected value. */
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
  /** A user selected icon value */
  icon?: string;
}

export type CapabilityReference = CapabilityReferenceRequest & {
  /** @example false */
  ephemeral?: boolean;
};

export type CapabilityReferenceRequest = BaseCapabilityReference & {
  config?: CapabilityConfiguration;
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
};

export interface CapabilityConfiguration {
  values: CapabilityConfigurationValue[];
}

export interface CapabilityConfigurationValue {
  /**
   * The path to the preference attribute that is being configured.
   * @example "thermostatMode.value"
   */
  key: string;
  /**
   * The range of values supported by the capability attribute. The range must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @maxItems 2
   * @minItems 2
   * @example "[1, 50]"
   */
  range?: number[];
  /**
   * The list of enumerated values that are supported for the capability attribute. The list of supported value must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @example "[ "cooling", "fan only", "heating", "idle" ]"
   */
  enabledValues?: string[];
  /**
   * The incremental step that increases or decreases for numeric values.
   * @format double
   * @default 1
   */
  step?: number;
}

export interface DeviceProfileConfig {
  /** Provides custom configuration for the automation view associated with the implicitly generated device configuration. */
  automation?: AutomationConfiguration;
}

/** Provides custom configuration for the automation view associated with the implicitly generated device configuration. */
export interface AutomationConfiguration {
  /** Provides custom configuration for each automation action item. */
  actions?: AutomationActionItemConfiguration[];
}

/** Provides custom configuration for an automation action item. For example, this configuration may be used exclude specific capabilities from an automation action item. */
export interface AutomationActionItemConfiguration {
  /** ID of the capability associated with the action */
  capability: string;
  config: {
    exclusion?: {
      exclude?: ExcludedActionItem[];
    };
  };
}

export interface ExcludedActionItem {
  /** @example "pictureMode" */
  capability?: string;
}

export interface BaseCapabilityReference {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategory {
  /** @example "Light" */
  name: string;
  /** @default "manufacturer" */
  categoryType: 'manufacturer' | 'user';
}

/**
 * Additional information about the device profile, limited to 10 entries.
 * @example {"firmWareVersion":"0.2.123","manufacturerName":"SmartThingsCommunity"}
 */
export type DeviceProfileMetadata = any;

export interface Links {
  next?: Link;
  previous?: Link;
}

/** @example {"component":"main","capability":"switchLevel","command":"setLevel","arguments":[80]} */
export interface DeviceCommand {
  /**
   * A UUID used for tracking the individual command.
   * This should be returned in the command response to correlate status of each command.
   * @format uuid
   */
  id: string;
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @default "main"
   */
  component: string;
  /** Capability that this command relates to. This must be a capability of the component. */
  capability: string;
  /** Name of the command, this must be valid for the capability. */
  command: string;
  /**
   * Arguments of the command.
   * All the required arguments defined in the capability's command argument definition must be provided.
   * The type of the arguments are dependent on the type of the capability's command argument.
   * Please refer to the capabilities definition at https://smartthings.developer.samsung.com/develop/api-ref/capabilities.html
   */
  arguments?: object[];
}

export type BackendDeviceDetails = Record<string, any>;

export type JsonObject = Record<string, object>;

export interface BackendDeviceCommands {
  /** the id of the device to execute the commands against */
  deviceId?: string;
  /** the parent id associated with the device */
  parentDeviceId?: string;
  /** An array of commands to execute on the Device. */
  commands?: DeviceCommand[];
  /** Key value pairs that were stored in the conductor for the device. */
  metadata?: Record<string, any>;
}

/** An array of backend device commands to execute. */
export type BatchBackendDeviceCommands = BackendDeviceCommands[];

export type ExecuteBatchDeviceCommandsResponse = object;

export interface DeviceCommandsResponse {
  results?: CommandResult[];
}

export interface CommandResult {
  /**
   * A UUID used for tracking the individual command.
   * @format uuid
   */
  id?: string;
  /**
   * `ACCEPTED`: the command is processing but it's outcome is unknown
   * `COMPLETED`: the command has successfully completed
   * `FAILED`: the command has failed
   */
  status?: CommandStatus;
}

/**
 * `ACCEPTED`: the command is processing but it's outcome is unknown
 * `COMPLETED`: the command has successfully completed
 * `FAILED`: the command has failed
 */
export enum CommandStatus {
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

/** The capability that is common to all devices in the group */
export interface DeviceGroupCapability {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

/** An empty object with future fields to be determined. */
export type DeleteDeviceResponse = object;

/** Collection of information records to associate with Device. */
export type DeviceData = DeviceDatum[];

/** Single information record for Device. */
export interface DeviceDatum {
  /** Information record unique identifier. */
  id?: string;
  /** Information record value. */
  value?: string;
}

/**
 * The label for the Device.
 * @example "Living room light."
 */
export type DeviceLabel = string;

export interface LegacyProperties {
  /** @example false */
  completedSetup?: boolean;
  /** @example "component-name" */
  componentName?: string;
  /** @example "Kitchen Outlet" */
  componentLabel?: string;
  /**
   * Error state for a widget device. This is a legacy property ported over from Data Management.
   * @example "OK"
   */
  errorState?: DeviceErrorState;
  firmwareVersion?: DeviceFirmwareResponse;
  /** @example "27dd7af4-fb5f-402a-8cb4-c3b4559e0d04" */
  groupId?: string;
  /**
   * The handlerVersion for the device. This is a legacy property ported over from Data Management.
   * @example "State.BETA"
   */
  handlerVersion?: State;
  /** @example false */
  isComponent?: boolean;
  /** @example 1 */
  joinFingerprintId?: number;
  /** @example "Kitchen Outlet" */
  label?: string;
  /** @example "27dd7af4-fb5f-402a-8cb4-c3b4559e0d04" */
  parentDeviceId?: string;
  /** @example "" */
  parentSmartAppId?: string;
  /** @example "fdc2cfda-d841-4465-9e82-d01e84fac9e0:NOT_APPROVED" */
  previousHandler?: string;
  /** @example "000D6F001619232E" */
  previousZigbeeId?: string;
  primaryTileName?: string;
  profileId?: string;
  /** Profile type for a widget device. This is a legacy property ported over from Data Management. */
  profileType?: ProfileType;
  /** Protocol Connection for a widget device. This is a legacy property ported over from Data Management. */
  protocolConnection?: DeviceProtocolConnection;
  rawDescription?: string;
  /** @example 4 */
  sortOrder?: number;
  /** @example "b720c262-2b8a-4371-8c45-eea38cbbb28d" */
  typeId?: string;
}

/** Error state for a widget device. This is a legacy property ported over from Data Management. */
export enum DeviceErrorState {
  OK = 'OK',
  ERROR = 'ERROR',
}

export interface DeviceFirmwareResponse {
  /**
   * The name of the deviceType for the device
   * @example "SmartSense Motion"
   */
  deviceType?: string;
  /** The Manufacturer code */
  manufacturer?: number;
  imageType?: number;
  fullVersion?: number;
  majorVersion?: number;
  minorVersion?: number;
  buildVersion?: number;
}

/** The handlerVersion for the device. This is a legacy property ported over from Data Management. */
export enum State {
  NOT_APPROVED = 'NOT_APPROVED',
  ALPHA = 'ALPHA',
  BETA = 'BETA',
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
  SELF_APPROVED = 'SELF_APPROVED',
  LATEST_APPROVED = 'LATEST_APPROVED',
}

/** Profile type for a widget device. This is a legacy property ported over from Data Management. */
export enum ProfileType {
  DTH1 = 'DTH_1',
  ENDPOINT_APP = 'ENDPOINT_APP',
  IR = 'IR',
  IR_OCF = 'IR_OCF',
  OCF = 'OCF',
  MQTT = 'MQTT',
  PENGYOU = 'PENGYOU',
  SHP = 'SHP',
  VIDEO = 'VIDEO',
  VIPER = 'VIPER',
  BLE = 'BLE',
  BLED2D = 'BLE_D2D',
  MOBILE = 'MOBILE',
  ZIGBEE = 'ZIGBEE',
  ZWAVE = 'ZWAVE',
  LAN = 'LAN',
}

/** Protocol Connection for a widget device. This is a legacy property ported over from Data Management. */
export enum DeviceProtocolConnection {
  CONNECTED = 'CONNECTED',
  REMOVED = 'REMOVED',
  NEEDS_REJOIN = 'NEEDS_REJOIN',
}

export type DeviceResponse = DeviceBase & {
  /** The identifier for the Device instance. */
  id?: DeviceId;
  /** The Device profile ID. */
  deviceProfileId?: DeviceProfileId;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /** Collection of preference records associated with Device. */
  preferences?: DevicePreferences;
  /** Device details for all child devices of the device. */
  childDevices?: ChildDevices;
};

export interface DeviceBase {
  /** Collection of information records to associate with Device. */
  deviceData?: DeviceData;
  /** The network-specific identifier of the device on the network */
  deviceNetworkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId: DriverId;
  /** The hub that the device is connected to. */
  hubId: HubId;
  /** The label for the Device. */
  label: DeviceLabel;
  /** The ID of the parent Device, if it exists. */
  parentDeviceId: ParentDeviceId;
  /** The ID of the Location with which the device is associated. */
  locationId: DeviceLocationId;
  /** Provisioning type for a widget device */
  provisioningState: ProvisioningState;
}

/**
 * The ID of the parent Device, if it exists.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
 */
export type ParentDeviceId = string;

/**
 * The ID of the Location with which the device is associated.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
 */
export type DeviceLocationId = string;

/**
 * The Device profile ID.
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */

// removed this line because it is a duplicate definition
// export type DeviceProfileId = string;

/** Collection of preference records associated with Device. */
export type DevicePreferences = DevicePreference[];

/** Single preference record for Device. */
export interface DevicePreference {
  /** Preference record unique identifier. */
  id: string;
  /** Preference record value. */
  value: any;
}

/** Device details for all child devices of the device. */
export type ChildDevices = ChildDeviceRef[];

/** An empty object with future fields to be determined. */
export type DeleteDeviceGroupResponse = object;

/** @example {"capability":"switchLevel","command":"setLevel","arguments":[100,1]} */
export interface DeviceGroupCommand {
  capability?: string;
  command?: string;
  arguments?: object[];
}

/** A group */
export interface DeviceGroup {
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
     */
    deviceId?: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
  /** Lowest common denominator capability of all the devices in the group */
  deviceGroupCapabilities: DeviceGroupCapability[];
}

export type ExecuteDeviceGroupCommandsResponse = object;

export type UpdateDeviceGroupResponse = object;

export type CreateDeviceGroupResponse = object;

export interface BackendDeviceGroupCommands {
  /** The id of the device group to execute the commands against */
  deviceGroupId?: string;
  /** An array of commands to execute on the device group */
  commands?: DeviceGroupCommand[];
}

/** @example {"values":{"temperatureOffset":{"preferenceType":"integer","value":3},"example.lightToggleDelay":{"preferenceType":"number","value":0.68},"example.featureEnabled":{"preferenceType":"boolean","value":false},"example.notificationMessage":{"preferenceType":"string","value":"It is hot"},"example.colorSelect":{"preferenceType":"string","value":"lightBlue"}}} */
export interface DevicePreferenceRequest {
  /** Map of PreferenceId to its stored values */
  values?: Record<string, PreferenceValue>;
}

export interface PreferenceValue {
  /** The type of preference this is. */
  preferenceType: PreferenceType;
}

export type IntegerPreferenceValue = PreferenceValue & {
  value: number;
};

export type NumberPreferenceValue = PreferenceValue & {
  value: number;
};

export type BooleanPreferenceValue = PreferenceValue & {
  value: boolean;
};

export type StringPreferenceValue = PreferenceValue & {
  value: string;
};

/** Simple object response for deleted entity. */
export type DeleteResponse = Record<string, any>;

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

export interface ListVirtualDevicesParams {
  locationId?: string;
}

export interface MigrateDthVirtualDeviceParams {
  /** The migrated devices will always be CLOUD-executed, even if they were previously locally executing. */
  ignoreLocal?: boolean;
}

export interface ExecuteBatchDeviceCommandsParams {
  /** Specifies whether the command should be executed in order or asynchronously. */
  ordered?: boolean;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://replicator.stinternal.net';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title replicator
 * @version 0.1.0
 * @baseUrl https://replicator.stinternal.net
 *
 * Virtual device backend
 */
export class ReplicatorApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  virtualdevices = {
    /**
     * @description Create a virtual device in a location you have access to.
     *
     * @tags Virtualdevices
     * @name CreateVirtualDevice
     * @summary Onboard a Virtual Device
     * @request POST:/virtualdevices
     * @secure
     */
    createVirtualDevice: (createVirtualDeviceRequest: VirtualDeviceCreateRequest, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/virtualdevices`,
        method: 'POST',
        body: createVirtualDeviceRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all virtual devices you own across all of your locations. If a location ID is supplied in the query parameters, the returned list of virtual devices will be filtered by the given location.
     *
     * @tags Virtualdevices
     * @name ListVirtualDevices
     * @summary List Virtual Devices
     * @request GET:/virtualdevices
     * @secure
     */
    listVirtualDevices: (query: ListVirtualDevicesParams, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/virtualdevices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Migrate an existing, DTH-backed virtual device to a Replicator device. The DTH that a device is backed by should have a prototype match, or it will not work.
     *
     * @tags Virtualdevices
     * @name MigrateDthVirtualDevice
     * @summary Migrate a DTH virtual device to Replicator
     * @request POST:/virtualdevices/migrate
     * @secure
     */
    migrateDthVirtualDevice: (
      query: MigrateDthVirtualDeviceParams,
      MigrateVirtualDeviceRequest: MigrateVirtualDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<MigrateVirtualDeviceResponse, ErrorResponse>({
        path: `/virtualdevices/migrate`,
        method: 'POST',
        query: query,
        body: MigrateVirtualDeviceRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Onboard a virtual device from a built-in template. The device must be created in a location for which you have device installation privileges. Virtual device templates provide a generic configuration for common virtual device types, simplifying the virtual device creation process and eliminating the need to know what device profiles or capabilities are required for a given device type to function.
     *
     * @tags Virtualdevices
     * @name CreateVirtualDeviceByPrototype
     * @summary Onboard a Prefabricated Virtual Device From a Built-in Template
     * @request POST:/virtualdevices/prototypes
     * @secure
     */
    createVirtualDeviceByPrototype: (
      createVirtualDeviceFromPrototypeRequest: VirtualDeviceFromPrototypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<Device, ErrorResponse>({
        path: `/virtualdevices/prototypes`,
        method: 'POST',
        body: createVirtualDeviceFromPrototypeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all virtual devices associated with a hub. Virtual devices associated with a hub are considered locally executable.
     *
     * @tags Virtualdevices
     * @name ListVirtualDevicesByHubId
     * @summary List Virtual Devices by Hub ID.
     * @request GET:/virtualdevices/hub/{hubId}/local
     * @secure
     */
    listVirtualDevicesByHubId: (hubId: string, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/virtualdevices/hub/${hubId}/local`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description For virtual devices that have attributes that cannot emit an event with a command, this endpoint allows you to force a virtual device to emit an event. This endpoint is heavily rate limited; do not use this endpoint to generate significant event volume.
     *
     * @tags Virtualdevices
     * @name EmitDeviceEvents
     * @summary Cause a Virtual Device to Emit an Event
     * @request POST:/virtualdevices/{deviceId}/events
     * @secure
     */
    emitDeviceEvents: (deviceId: string, body: DeviceEventsRequest, params: RequestParams = {}) =>
      this.request<
        {
          /** The list of state changes for each event created in the order in the create request */
          stateChanges?: boolean[];
        },
        ErrorResponse
      >({
        path: `/virtualdevices/${deviceId}/events`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  devicebackends = {
    /**
     * @description Execute commands on multiple devices. Commands will be executed simultaneously where possible.
     *
     * @tags devicebackends
     * @name ExecuteBatchDeviceCommands
     * @summary Execute commands on multiple devices
     * @request POST:/devicebackends/devicecommands
     * @secure
     */
    executeBatchDeviceCommands: (
      query: ExecuteBatchDeviceCommandsParams,
      executeCapabilityBatchCommand: BatchBackendDeviceCommands,
      params: RequestParams = {},
    ) =>
      this.request<ExecuteBatchDeviceCommandsResponse, ErrorResponse>({
        path: `/devicebackends/devicecommands`,
        method: 'POST',
        query: query,
        body: executeCapabilityBatchCommand,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Used by Gizmo to notify the backend about the creation of a device group. The backend is only notified with the subset of devices in the device group that are managed by the backend.
     *
     * @tags devicebackends
     * @name CreateDeviceGroup
     * @summary Create a device group
     * @request POST:/devicebackends/devicegroups/{deviceGroupId}
     * @secure
     */
    createDeviceGroup: (deviceGroupId: string, deviceGroup: DeviceGroup, params: RequestParams = {}) =>
      this.request<CreateDeviceGroupResponse, ErrorResponse>({
        path: `/devicebackends/devicegroups/${deviceGroupId}`,
        method: 'POST',
        body: deviceGroup,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Used by Gizmo the notify the backend about any device group membership/capability changes.The backend is only notified with the subset of devices in the device group that are managed by the backend.
     *
     * @tags devicebackends
     * @name UpdateDeviceGroup
     * @summary Update device group
     * @request PUT:/devicebackends/devicegroups/{deviceGroupId}
     * @secure
     */
    updateDeviceGroup: (deviceGroupId: string, deviceGroup: DeviceGroup, params: RequestParams = {}) =>
      this.request<UpdateDeviceGroupResponse, ErrorResponse>({
        path: `/devicebackends/devicegroups/${deviceGroupId}`,
        method: 'PUT',
        body: deviceGroup,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Gizmo will notify the device backed upon device group deletion. The backend should perform any necessary cleanup.
     *
     * @tags devicebackends
     * @name DeleteDeviceGroup
     * @summary Delete the device group
     * @request DELETE:/devicebackends/devicegroups/{deviceGroupId}
     * @secure
     */
    deleteDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeleteDeviceGroupResponse, ErrorResponse>({
        path: `/devicebackends/devicegroups/${deviceGroupId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Used by Gizmo to notify the backend of changes to the preferences for a device. Preferences are user managed and affect the device by contolling things like disabling / enabling features, calibrating measurements, etc.
     *
     * @tags devicebackends
     * @name SyncPreferences
     * @summary Preferences syncronization
     * @request PUT:/devicebackends/{deviceId}/preferences
     * @secure
     */
    syncPreferences: (deviceId: string, preferences: DevicePreferenceRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/devicebackends/${deviceId}/preferences`,
        method: 'PUT',
        body: preferences,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags devicebackends
     * @name BackendDeleteDevice
     * @summary Delete device as platform conductor.
     * @request DELETE:/devicebackends/{deviceId}
     * @secure
     */
    backendDeleteDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeleteResponse, ErrorResponse>({
        path: `/devicebackends/${deviceId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags devicebackends
     * @name GetBackendDetails
     * @summary Get virtual device details.
     * @request GET:/devicebackends/{deviceId}
     * @secure
     */
    getBackendDetails: (deviceId: string, params: RequestParams = {}) =>
      this.request<ReplicatorDevice, ErrorResponse>({
        path: `/devicebackends/${deviceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send a command to a virtual device. We currently only support 2 types of commands: `enum commands`: These are commands specified as part of an attribute definition that always have a set expected attribute state that results from them `setters`: These commands allow for user input arguments, but are also tied to a particular attribute Aside from these types of commands, you can specify a custom command mapping during device join to handle complex commands.
     *
     * @tags devicebackends
     * @name SendBackendCommands
     * @summary Issue command to a virtual device.
     * @request POST:/devicebackends/{deviceId}/commands
     * @secure
     */
    sendBackendCommands: (deviceId: string, body: BackendDeviceCommands, params: RequestParams = {}) =>
      this.request<
        {
          /** The list of state changes for each event created in the order in the create request */
          stateChanges?: boolean[];
        },
        ErrorResponse
      >({
        path: `/devicebackends/${deviceId}/commands`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  internal = {
    /**
     * @description Migrate or clone an existing device to a replicator device.
     *
     * @tags internal
     * @name Replicate
     * @summary Migrate or clone a replicator device.
     * @request POST:/internal/replicate
     * @secure
     */
    replicate: (body: ReplicateRequest, params: RequestParams = {}) =>
      this.request<
        {
          /**
           * The identifier for the device instance.
           * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
           */
          deviceId: string;
          /**
           * The identifier for the owner of the device instance.
           * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
           */
          ownerId?: string;
          /**
           * The name that the device integration (Device Handler or SmartApp) defines for the device.
           * @example "color.light.100x"
           */
          name?: string;
          /**
           * The name that a user chooses for the device. This defaults to the same value as name.
           * @format ^([\S]{1}|[\S]+.*?[\S]+)$
           * @example "color.light.100x"
           */
          label?: string;
          /**
           * The device manufacturer code.
           * @example "010F-0B01-2002"
           */
          deviceManufacturerCode?: string;
          /**
           * The device manufacturer name.
           * @example "SmartThings"
           */
          manufacturerName: string;
          /**
           * The device model.
           * @example "FGMS-001"
           */
          deviceModel?: string;
          /**
           * An non-unique id that is used to help drive UI information.
           * @example "VD-STV_2018_K"
           */
          presentationId: string;
          /**
           * The ID of the Location with which the device is associated.
           * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
           * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
           */
          locationId?: string;
          /**
           * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
           * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
           * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
           */
          roomId?: string;
          /** The IDs of all locations this device is shared with. */
          sharedLocations?: SharedLocation[];
          /** The IDs of all compenents on the device. */
          components?: DeviceComponent[];
          /** The time when the device was created at. */
          createTime?: string;
          healthState?: IdLessHealthState;
          /** The id of the Parent device. */
          parentDeviceId?: string;
          /** Device details for all child devices of the device. */
          childDevices?: ChildDeviceRef[];
          profile?: DeviceProfileReference;
          /** Device Profile information for a SmartApp. This field will be empty if device type is not ENDPOINT_APP. */
          app?: AppDeviceDetails;
          /** Bluetooth device information. This field will be empty if device type is not BLE. */
          ble?: BleDeviceDetails;
          /** Bluetooth device to device information. This field will be empty if device type is not BLE_D2D. */
          bleD2D?: BleD2DDeviceDetails;
          /** Device Profile information for DTH. This field will be empty if device type is not DTH. */
          dth?: DthDeviceDetails;
          /** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
          lan?: LanDeviceDetails;
          /** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
          zigbee?: ZigbeeDeviceDetails;
          /** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
          zwave?: ZwaveDeviceDetails;
          /** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
          matter?: MatterDeviceDetails;
          /** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
          edgeChild?: EdgeChildDeviceDetails;
          /** HUB device information. This field will be empty if the device type is not HUB. */
          hub?: HubDeviceDetails;
          /** MOBILE device information. This field will be empty if the device type is not MOBILE. */
          mobile?: MobileDeviceDetails;
          /** IR device information. This field will be empty if device type is not IR. */
          ir?: IrDeviceDetails;
          /** IR_OCF device information. This field will be empty if device type is not IR_OCF. */
          irOcf?: IrDeviceDetails;
          /** OCF device information. This field will be empty if device type is not OCF. */
          ocf?: OcfDeviceDetails;
          /** Viper device information. This field will be empty if device type is not VIPER. */
          viper?: ViperDeviceDetails;
          /** Group device information. This field will be empty if device type is not GROUP. */
          group?: GroupDeviceDetails;
          /** Virtual device information. This field will be empty if device type is not VIRTUAL. */
          virtual?: VirtualDeviceDetails;
          /**
           * The type of device integration.
           * All types besides ENDPOINT_APP will have profile populated.
           * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
           * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
           * If the type is IR, the details are in the "ir" field.
           * If the type is IR_OCF, the details are in the "irOcf" field.
           * If the type is VIPER, the details are in the "viper" field.
           */
          type: DeviceIntegrationType;
          /**
           * A field to store an ID from a system external to SmartThings.
           * @maxLength 64
           * @example "Th13390"
           */
          externalId?: string;
          /**
           * *DEPRECATED* please use `presentationId`
           * Vendor id of the device, used for UI.
           */
          vid?: string;
          /**
           * *DEPRECATED* please use `manufacturerName`
           * Manufacturer model number, used for UI.
           */
          mnmn?: string;
          /** The OCF device type (resource), used for UI. */
          ocfDeviceType?: string;
          /** Restriction tier of the device, if any. */
          restrictionTier: number;
          /**
           * List of client-facing action identifiers that are currently permitted for the user.
           * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
           * If the value of this property is null (or absent), then no permission-related information is being provided.
           *   <ul>
           *   <li> w:devices - the user can change device details
           *   <li> w:devices:locationId - the user can move the device from a location
           *   <li> w:devices:roomId - the user can move or remove the device from a room
           *   <li> x:devices - the user can execute commands on the device
           *   <li> d:devices - the user can uninstall the device
           *   </ul>
           * @uniqueItems true
           */
          allowed?: 'w:devices' | 'w:devices:locationId' | 'w:devices:roomId' | 'x:devices' | 'd:devices';
          /** The location of a device on a floorplan map, if any. */
          indoorMap?: IndoorMap;
        },
        ErrorResponse
      >({
        path: `/internal/replicate`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
